module.exports = __webpack_public_path__ + "img/730231271.bdf0bb47.jpg";